import { useState, useMemo } from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import {
  PostMetricWithSoundbites,
  PopularLinksWidgetsType
} from 'components/widget/PopularLinksWidgets/types'
import { addSelectionFilterToWidgetSetting, convertToInsightContentSetting } from './utils'

const useSelectedInsights = (
  isModalOpen: boolean,
  widgetSetting: PopularLinksWidgetsType,
  setIsModalOpen: (isOpen: boolean) => void
) => {
  const [selectedInsight, setSelectedInsight] = useState<PostMetricWithSoundbites>()

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selectedInsight) {
      return convertToInsightContentSetting(widgetSetting, selectedInsight)
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsight])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selectedInsight) {
      return addSelectionFilterToWidgetSetting(widgetSetting)
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsight])

  const handleRowClick = (targetRow: PostMetricWithSoundbites) => {
    setSelectedInsight(targetRow)
    setIsModalOpen(true)
  }

  return { selectedInsight, detailSetting, handleRowClick, widgetSettingWithSelection }
}

export default useSelectedInsights
